<template>
	<svg viewBox="0 0 34 32">
		<slot></slot>
		<path d="M24.502 20.183l2.716 11.817-10.396-6.237-10.396 6.239 2.718-11.816-9.144-7.963 12.077-1.064 4.745-11.158 4.745 11.158 12.077 1.064-9.143 7.961z" />
	</svg>
</template>
